import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import NotFound from "./screens/NotFound";
import MainPage from "./screens/MainPage";
import Locations from "./screens/Locations";
import About from "./screens/About";
import Products from "./screens/Products";
import Contact from "./screens/Contact";
import History from "./screens/History";
import Mission from "./screens/Mission";
import Services from "./screens/Services";
import ExpertsTips from "./screens/ExpertsTips";

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/historia" element={<History />} />
        <Route path="/mision" element={<Mission />} />
        <Route path="/servicios" element={<Services />} />
        <Route path="/ExpertsTips" element={<ExpertsTips />} />
        <Route path="/productos" element={<Products />} />
        <Route path="/marca" element={<About />} />
        <Route path="/About" element={<Navigate to="/marca" replace />} />
        <Route path="/Search" element={<MainPage />} />
        <Route path="/Main" element={<MainPage />} />
        <Route path="/cedis" element={<Locations />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/Contact" element={<Navigate to="/contacto" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
